"use strict";

exports.__esModule = true;
exports.base = void 0;

var _base = require("./base");

exports.base = _base.base;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-icons/themes/index.js
// module id = 391
// module chunks = 1